export default __webpack_public_path__ + "static/media/logo-white.97f946a6.svg";